'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _SiteDescription = require('./SiteDescription.scss');var _SiteDescription2 = _interopRequireDefault(_SiteDescription);
var _ = require('../');
var _realEstate = require('../../translations/description/realEstate.json');var _realEstate2 = _interopRequireDefault(_realEstate);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

SiteDescription = function (_Component) {_inherits(SiteDescription, _Component);function SiteDescription() {var _temp, _this, _ret;_classCallCheck(this, SiteDescription);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.










    setContent = function (locale) {
      // eslint-disable-next-line
      _this.content = require('../../translations/description/' + locale + '.json');
    }, _this.

    renderItem = function (item) {return (
        _react2.default.createElement('div', { key: item, className: _SiteDescription2.default.descriptionItem },
          item === 'search-v2' ?
          _react2.default.createElement('div', null,
            _react2.default.createElement('i', { className: 'icon icon-search-v2' },
              _react2.default.createElement('span', { className: 'path1' }),
              _react2.default.createElement('span', { className: 'path2' }))) :



          _react2.default.createElement('div', null, _react2.default.createElement('i', { className: 'icon-' + item })),


          _react2.default.createElement('span', null, _this.content[item])));}, _temp), _possibleConstructorReturn(_this, _ret);}SiteDescription.prototype.componentWillMount = function componentWillMount() {this.setContent(this.props.locale);};SiteDescription.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {var locale = _ref.locale;if (this.props.locale !== locale) {this.setContent(locale);}};SiteDescription.prototype.



  render = function render() {var _this2 = this;
    var items = Object.keys(this.content);
    var columns = [items.slice(0, 2), items.slice(2)];

    return (
      _react2.default.createElement('div', { className: _SiteDescription2.default.descriptionBlock, dir: 'auto' },
        _react2.default.createElement('div', { className: _SiteDescription2.default.descriptionList },
          _react2.default.createElement('div', { className: _SiteDescription2.default.descriptionTitle }, this.props.title),
          _react2.default.createElement('div', null,
            columns.map(function (column) {return (
                _react2.default.createElement('div', { className: _SiteDescription2.default.columnWrapper, key: column[0] + '-column' },
                  column.map(function (item) {return _this2.renderItem(item);})));}))),




        _react2.default.createElement('div', { className: _SiteDescription2.default.realEstateBlock },
          _react2.default.createElement('div', null,
            _react2.default.createElement('div', { className: _SiteDescription2.default.title }, _realEstate2.default[this.props.locale].forSale.title),

            _react2.default.createElement('pre', null,
              _react2.default.createElement(_.PlainHtml, { content: _realEstate2.default[this.props.locale].forSale.text }))),



          _react2.default.createElement('div', null,
            _react2.default.createElement('div', { className: _SiteDescription2.default.title }, _realEstate2.default[this.props.locale].forRent.title),
            _react2.default.createElement('pre', null,
              _react2.default.createElement(_.PlainHtml, { content: _realEstate2.default[this.props.locale].forRent.text }))))));





  };return SiteDescription;}(_react.Component);exports.default = SiteDescription;


SiteDescription.propTypes = {
  locale: _propTypes2.default.string,
  title: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SiteDescription/SiteDescription.js
// module id = 2890
// module chunks = 0